import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

import { MenuHeader } from 'src/modules/designStudio/components/DesignMenu/Menu/MenuHeader';
import { TemplateProductCategory } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/TemplateProductCategory';
import type { TemplateProductBreakdown } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/types';
import { TemplateProductCategories } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/types';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface TemplateProductListProps extends BoxProps {
  productBreakdown: TemplateProductBreakdown;
  closeMenu: () => void;
  onBack: () => void;
  onMaterialSelected: (material: MaterialGroup) => void;
}

export const TemplateProductList = ({
  closeMenu,
  onBack,
  onMaterialSelected,
  productBreakdown,
  ...props
}: TemplateProductListProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <Box
      alignItems="stretch"
      bottom="0"
      flexDirection="column"
      height="100%"
      left="0"
      overflowX="hidden"
      padding="600"
      position="absolute"
      right="0"
      top="0"
      {...props}
    >
      <MenuHeader
        closeMenu={closeMenu}
        headerText={t('menu.template.productsTitle')!}
        onBack={onBack}
      />
      {Object.keys(TemplateProductCategories).map(category =>
        productBreakdown[category as TemplateProductCategories].length > 0 ? (
          <TemplateProductCategory
            category={category as TemplateProductCategories}
            key={category}
            materials={productBreakdown[category as TemplateProductCategories]}
            onMaterialSelected={onMaterialSelected}
          />
        ) : null,
      )}
    </Box>
  );
};
